import { createSlice } from "@reduxjs/toolkit";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IWallet } from "api/types/_wallet";
import { getWallets } from "./thunk";


export interface IState {
  wallets: ResponseData<IWallet[]> & PaginationResponse | null,
  isWalletLoading: boolean,
  isWalletSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  wallets: null,
  isWalletLoading: false,
  isWalletSuccess: false,

  error: {},
};

const WalletSlice = createSlice({
  name: "Wallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Wallets
    builder.addCase(getWallets.pending, (state: IState, action: any) => {
      state.isWalletLoading = true
    });
    builder.addCase(getWallets.fulfilled, (state: IState, action: any) => {
      state.wallets = {
        list: action.payload?.data || [],
        pagination: {
          total: Number(action.payload?.data?.length || 0),
          page: 1,
          limit: 100,
        }
      } as any;
      state.isWalletSuccess = true;
      state.isWalletLoading = false;
    });
    builder.addCase(getWallets.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isWalletSuccess = false;
      state.isWalletLoading = false;
    });
  },
});

export default WalletSlice.reducer;